import React from 'react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';

import IntegrationsProvider from 'screens/Integrations/context/IntegrationsProvider';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import SubmissionSummaryProvider from 'screens/Integrations/SubmissionSummary/context/SubmissionSummaryProvider';
import MccainProvider from '../../context/Provider';
import BaseMcCainIntegration from '../BaseMccainIntegration';

const blankValues = {
  selectedProperties: [],
  submitDate: new Date(),
  selectedFarm: 0,
  selectedCropSeasons: [{}],
  mccainVendorId: '',
  cropSeasonStartDate: '',
  cropSeasonEndDate: ''
};

const MccainParentProvider = () => {
  const { id } = useParams();

  return (
    <IntegrationsProvider>
      <MccainProvider>
        <Formik initialValues={blankValues}>
          {() => (
            <SubmissionSummaryProvider
              integrationType={INTEGRATIONS.mccain}
              submissionId={id}
            >
              <BaseMcCainIntegration />
            </SubmissionSummaryProvider>
          )}
        </Formik>
      </MccainProvider>
    </IntegrationsProvider>
  );
};

export default MccainParentProvider;
